<template>
  <div id="grid-visita">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="newVisita()">Agregar Visita</v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <v-layout justify-content: center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionesSelect"
            label="Region"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="comunaValue"
            :items="comunasSelect"
            item-text="nombre"
            item-value="code"
            label="Comuna"
          ></v-select>
        </v-flex>
        <!-- <v-flex xs12 md4>
          <v-select
            v-model="rbdValue"
            :items="rbdSelect"
            label="RBD"
          ></v-select>
        </v-flex> -->
        <v-flex xs12 md4>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="name"
            item-value="code"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar contratos"
          @click="filterVisit()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout justify-center>
        <v-flex lg12>
          <v-data-table
            :headers="headers"
            :items="visitas"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.region }}</td>
              <td class="text-xs-left">{{ props.item.comuna }}</td>
              <td class="text-xs-left">{{ props.item.rbd }}</td>
              <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <td class="text-xs-left">{{ props.item.letra }}</td>
              <td class="text-xs-left">{{ props.item.fecha_visitaPrev }}</td>
              <td>
                <v-btn
                  v-if="
                    (usuarioLoggedTipe == 'PROVEEDOR' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR') &&
                    (props.item.fecha_visitaPrev == null ||
                      props.item.fecha_visitaPrev == '' ||
                      props.item.fecha_visitaPrev == undefined)
                  "
                  class="btn-sigas"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="light-blue"
                  small
                  title="Agendar Visita"
                  @click="newVisita(props.item.id)"
                >
                  <v-icon>assignment</v-icon>
                </v-btn>
                <v-btn
                  class="btn-sigas"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="blue darken-4"
                  small
                  title="Ver Visita Agendada"
                  @click="viewVisitaPre(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA VISITAS -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template
                  v-if="
                    usuarioLoggedTipe == 'PROVEEDOR' ||
                    usuarioLoggedTipe == 'ADMINISTRADOR'
                  "
                >
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="light-blue"
                    small
                  >
                    <v-icon>assignment</v-icon> </v-btn
                  >&nbsp;Agendar visita
                </template>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="blue darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >&nbsp;Consultar visita prevista
                </template>
              </td>
            </div>
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import { misMixins } from "@/mixins/myMixing.js";
import Loading from "@/views/ui/Loading.vue";
export default {
  name: "grid-visita",
  components: {
    Loading,
  },
  mixins: [misMixins],
  props: {},
  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      contratoId: "",
      allowSpaces: false,
      visitas: [],
      filter: false,
      visitaGrid: 0,
      regionesSelect: [],
      regionValue: null,
      comunasSelect: [],
      comunaValue: null,
      tipoPruebaValue: null,
      tipoPruebaSelect: [],
      rbdSelect: [],
      rbdValue: null,
      nivelSelect: [],
      nivelValue: null,
      dialogLoading: false,
      loading: false,
      dialog: false,
      menu1: false,
      idVisitaUpdate: "",
      headers: [
        { text: "Region", align: "left", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        { text: "RBD", sortable: false, value: "rbd" },
        { text: "Tipo Prueba", sortable: false, value: "tipoPrueba" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "Letra", sortable: false, value: "letra" },
        { text: "Fecha Visita Prevista", sortable: false, value: "fechapre" },
        { text: "Acciones visitas", sortable: false, value: "" },
      ],
    };
  },
  mounted() {
    this.contratoId = this.$store.getters.contratoStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
      this.loadData();
    } else {
      //this.loadDataVisitas();
    }
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.loadData();
  },
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadVisitasFilter() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        comuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        tipoPrueba:
          this.tipoPruebaValue && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
      };
      return await axios
        .post("/visitaAplicacion/filter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    submit() {
      this.$v.$touch();
    },
    async loadData() {
      this.loading = true;
      this.visitas = await this.loadVisitasFilter();
      this.miPaginacion.totalItems = this.visitas.length;
      if (this.visitas.length > 0) {
        this.loadComuna();
        this.loadNivelSelect();
        this.loadRegionSelect();
        this.loadPruebaSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.visitas.forEach(function (d) {
        let index = niv.findIndex((x) => x.nivel == d.nivel);
        if (index === -1) {
          niv.push(d.nivel);
        }
      });
      this.nivelSelect = niv;
    },

    loadPruebaSelect() {
      let tip = [];
      this.visitas.forEach(function (d) {
        let index = tip.findIndex((x) => x.tipoPrueba == d.tipoPrueba);
        if (index === -1) {
          tip.push(d.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    loadRegionSelect() {
      let reg = [];
      this.visitas.forEach(function (d) {
        if (d.region != null) {
          let index = reg.findIndex((x) => x.code == d.idRegion);
          if (index === -1) {
            if (d.idRegion != null && d.idRegion != "") {
              reg.push({ name: d.region, code: d.idRegion });
            }
          }
        }
      });
      this.regionesSelect = reg;
    },
    loadComuna() {
      let rc = [];
      this.visitas.forEach(function (d) {
        let index = rc.findIndex((x) => x.comuna == d.comuna);
        if (index === -1) {
          if (d.comuna != null && d.comuna != "") {
            rc.push(d.comuna);
          }
        }
      });
      this.comunasSelect = rc;
    },
    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.rbdValue = "";
      this.tipoPruebaValue = "";
      this.nivelValue = "";
      //this.estadoValue = "";
      this.loadData();
    },
    filterVisit() {
      this.loadData();
    },
    reloadVisitas() {
      this.visitaGrid += 1;
    },

    newVisita() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },

    viewVisitaPre(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { id: id, tipeView: "consultaPrevista" },
        });
      }, 1000);
    },
    viewVisitaReal(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { id: id, tipeView: "consultaRealizada" },
        });
      }, 1000);
    },
    editVisita(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { id: id, tipeView: "modificaVisita" },
        });
      }, 1000);
    },
    reloadGrid() {
      this.dialog = false;
      this.$parent.reloadVisitas();
    },
    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    editFecha(id) {
      this.dialog = true;
      this.idVisitaUpdate = id;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
